"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESocialsActionTypes = void 0;
let ESocialsActionTypes = exports.ESocialsActionTypes = /*#__PURE__*/function (ESocialsActionTypes) {
  ESocialsActionTypes["Expand"] = "socials/expand";
  ESocialsActionTypes["PhoneChanged"] = "socials/phone/changed";
  ESocialsActionTypes["EmailChanged"] = "socials/email/changed";
  return ESocialsActionTypes;
}({});